import { toast } from "react-toastify";
import { ApiManager } from "../../../core/api-manager";

/**
 * Funzione che allinea il USER idAuthory a idUserGroup
 * 
 * Richiamata dal hook ONUPDATE e ONINSERT
 */

export async function normalizeAuthority(idRecord) {

    if( !idRecord ) {
        toast.error('id non valido', { 
            position: 'bottom_right', 
            autoClose: true, 
            closeButton: true });

        const response = {
            action: 'normalize_authority',
            success: 0,
            message: 'id non valido'
        };
        console.log(response);
        return response;
    };

    return await ApiManager.sendAuthenticatedRequest('/custom/normalize_authority', { idRecord: idRecord }).then(response => {
        if (response.success === 1) {
            toast.success('gruppo e comune allineati', {
                position: 'bottom_right',
                autoClose: true,
                closeButton: true,
            });
        }else{
            toast.error('impossibile allineare gruppo e comune', {
                position: 'bottom_right',
                autoClose: true,
                closeButton: true,
            });
        }
        console.log({...response , action: 'normalize_authority'});
        return response;
    });

}